import { useEffect } from "react";
import numeral from "numeral";
import "numeral/locales";
import { LANGUAGES, useLanguage } from "./languageContextHooks";

const numeralLocaleMap: { [key in LANGUAGES]: string } = {
  [LANGUAGES.EN_UK]: "en-gb",
  [LANGUAGES.EN_US]: "en",
  [LANGUAGES.ES]: "es",
  [LANGUAGES.DE]: "de",
  [LANGUAGES.FR]: "fr",
  [LANGUAGES.IT]: "it",
  [LANGUAGES.NL]: "nl-nl",
  [LANGUAGES.NO]: "no",
  [LANGUAGES.PL]: "pl",
  [LANGUAGES.PT]: "pt-pt",
  [LANGUAGES.RU]: "ru",
};

const DEFAULT_LOCALE = "es";

const usePriceFormatter = () => {
  const { language } = useLanguage();

  useEffect(() => {
    numeral.locale(numeralLocaleMap[language] ?? DEFAULT_LOCALE);
  }, [language]);

  const format = (price?: string | number) => {
    if (price === undefined) return "";
    return numeral(+price).format("0,0.00");
  };

  return {
    format,
  };
};

export default usePriceFormatter;
